module.exports = __webpack_public_path__ + "static/media/ic_x_bk.b735a9ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/ic_x_bk.svg
// module id = 402
// module chunks = 21